import { useMemo } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import useReorderQuestions from "./useReorderQuestions";
import { txt } from "../../../services/translation";

export default function useUpdateQuestion(){

    const {quizId} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = useMemo(() => ['design', quizId, 'questions'], [quizId]);

    const reorderQuestions = useReorderQuestions()

    return (question) => {

        let newQuestion = {...question, edit: false};

        const oldQuestions = [...queryClient.getQueryData(queryKey)];

        let newQuestions = [...queryClient.getQueryData(queryKey)].filter(q => q.id !== newQuestion.id);
        newQuestions.push(newQuestion);
        newQuestions = reorderQuestions(newQuestions)
        queryClient.setQueryData(queryKey, newQuestions);

        API.put(`/design/questions/${newQuestion.id}`, newQuestion)
            .then(r => {
                console.log(r.data)
                API.put('/design/questions/reorder', newQuestions)
            })
            .catch(() => {
                queryClient.setQueryData(queryKey, oldQuestions)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}